export default __webpack_public_path__ + "static/media/R5C_8059.801cd2a9.jpg";